import { render, staticRenderFns } from "./weiyuanLvzhi.vue?vue&type=template&id=56640335&scoped=true&"
import script from "./weiyuanLvzhi.vue?vue&type=script&lang=js&"
export * from "./weiyuanLvzhi.vue?vue&type=script&lang=js&"
import style0 from "./weiyuanLvzhi.vue?vue&type=style&index=0&id=56640335&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56640335",
  null
  
)

export default component.exports